import { createContext } from "react";

const GlobalContext = createContext()

export const Provider = GlobalContext.Provider

export const Consumer = GlobalContext.Consumer


export default  GlobalContext;